'use strict';

var buildNumberUnitMethods = require('../internal/buildNumberUnitMethods');

buildNumberUnitMethods();


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/build/buildNumberUnitMethodsCall.js
// module id = 1
// module chunks = 1